import $ from 'jquery';

class Search {
    constructor (){
        this.resultsDivWrap = $('.search-results');
        this.resultsDiv = this.resultsDivWrap.find('.search-results__results');
        this.searchField = $('.search-input');
        this.searchPopup = $('.open-search');
        this.recentlyViewed = this.resultsDivWrap.find(".search-results__recent");
        this.events();
        this.previousValue;
        this.typingTimer;
        
    }

    // List of events
    events(){
        this.searchField.on("click", function(event) {
            event.stopPropagation();
            this.openOverlay();
        }.bind(this));
        $(document).on('keydown', this.keyPressDispatcher.bind(this));
        $(window).on('click', this.closeOverlay.bind(this));
        // alle links worden gesaved in recent bekeken in de search.
        this.resultsDivWrap.find('a').on('click', this.addToRecent);
        this.searchField.on('keyup', this.typingLogic.bind(this));
        this.resultsDivWrap.find('.search-results__recent-clear').on('click', this.clearRecent.bind(this));
        this.searchPopup.on('click', this.popupSwitch);
    }


    // Methods
    typingLogic(e) {
        const searchField = $(e.target);  // Get the specific search input that triggered the event

        // Only if the search input is being changed. No arrow keys
        if (this.previousValue != searchField.val()) {
            clearTimeout(this.typingTimer);
            if (searchField.val() && searchField.val().length > 3) {
                this.resultsDivWrap.addClass('loading');
                // Pass the specific searchField to getResults
                this.typingTimer = setTimeout(() => this.getResults(searchField), 500);
            } else {
                this.resultsDiv.html('');
                this.resultsDivWrap.removeClass('loading');
                this.resultsDivWrap.removeClass('has-value');
            }
        }

        // Update previousValue
        this.previousValue = searchField.val();
    }

    getResults(searchField) {
        /* Custom Wordpress Rest API */
        $.getJSON(wemake.root_url + '/wp-json/wemake/v1/search?term=' + searchField.val(), (results) => {
            if(this.hasAnyValue(results)){
                this.resultsDivWrap.addClass('has-value');
                this.resultsDiv.html('');
            }
            else{
                this.resultsDivWrap.removeClass('has-value');
                this.resultsDiv.html('Geen resultaten gevonden voor deze zoekopdracht.');
            }
    
            // Function to limit results to 4 and add custom "Bekijk alle..." link
            const limitResults = (items, customLink, linkText) => {
                let html = '';
                let limitedItems = items.slice(0, 4);
                limitedItems.forEach(item => {
                    html += `<li><a href="${item.permalink}" data-id="${item.id}">${item.title}</a></li>`;
                });
                // Check if there are more than 4 items, then add custom "Bekijk alle..." link
                if (items.length > 4 && linkText != '') {
                    html += `<li><a class="chevron" href="${customLink}">${linkText}</a></li>`;
                }
                return html;
            };
    
            // Products
            if (results.products.length){
                this.resultsDiv.append(`
                    <ul class="d-f fd-c gap-10">
                    <li><strong>Producten</strong></li>
                    ${limitResults(results.products, '/winkel', 'Bekijk alle modellen')}
                    </ul>
                `);
            }
    
            // Projects
            if (results.projects.length){
                this.resultsDiv.append(`
                    <ul class="d-f fd-c gap-10">
                    <li><strong>Projecten</strong></li>
                    ${limitResults(results.projects, '/projecten', 'Bekijk alle projecten')}
                    </ul>
                `);
            }
    
            // General Info (Pages and Posts)
            if (results.generalInfo.length){
                this.resultsDiv.append(`
                    <ul class="d-f fd-c gap-10">
                    <li><strong>Pagina's</strong></li>
                    ${limitResults(results.generalInfo, '/', '')}
                    </ul>
                `);
            }
    
            // Vacatures
            if (results.vacatures.length){
                this.resultsDiv.append(`
                    <ul class="d-f fd-c gap-10">
                    <li><strong>Vacatures</strong></li>
                    ${limitResults(results.vacatures, '/vacatures', 'Bekijk alle vacatures')}
                    </ul>
                `);
            }
    
            // Attach click handler to the links
            this.resultsDiv.find('a').on('click', this.addToRecent);
            this.resultsDivWrap.removeClass('loading');
        });        
    }

    keyPressDispatcher(e){
        if (e.keyCode == 83 && !this.isOverlayOpen && !$('input, textarea').is(':focus')){
            this.openOverlay();
        }

        if (e.keyCode == 27){
            this.closeOverlay();
        }
    }

    openOverlay(){
        this.resultsDivWrap.addClass('active');
        this.searchField.addClass('active');
        this.searchField.focus();
    }

    closeOverlay(){
        this.resultsDivWrap.removeClass('active');
        this.searchField.removeClass('active');
    }

    // When a user clicks on a page in the search. Save it in the meta for the user.
    addToRecent(e){
        let id = $(this).data('id');
        
        $.ajax({ 
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'update_recently_viewed', 
                id: id,
                _wpnonce: wemake.nonce,
            },
            error: function(error) {
                console.error('Error adding product to cart:', error);
            }
        });
    }

    clearRecent(e){
        e.stopPropagation();
        $.ajax({ 
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'clear_recently_viewed', 
                _wpnonce: wemake.nonce,
            },
            success: (response) => {
                this.recentlyViewed.remove();
            },
            error: function(error) {
                console.error('Error adding product to cart:', error);
            }
        });
    }

    hasAnyValue(data) {
        for (let key in data) {
            if (Array.isArray(data[key]) && data[key].length > 0) {
                return true; 
            }
        }
        return false; 
    }

    popupSwitch(){
        let inactiveIcon = $('.search-popup-icon-inactive');
        let activeIcon = $('.search-popup-icon-active');

        if (inactiveIcon.hasClass('active')){
            inactiveIcon.removeClass('active');
        }
        else{
            inactiveIcon.addClass('active');
        }

        if (activeIcon.hasClass('active')){
            activeIcon.removeClass('active');
        }
        else{
            activeIcon.addClass('active');
        }
    }
}

export default Search